import {
  generalTerm,
} from '@/constants/locales/de.shared.ts';

export default {
  setpoints: {
    header: 'Sollwerte',
  },
  properties: {
    header: 'Eigenschaften',
    representativeCouponDiameterLabel: generalTerm.representativeDiameter,
    halfInfiniteRadio: 'Einseitig (Halbunendlich)',
    shapeOrientedRadio: 'Beidseitig',
  },
  carburizing: {
    header: 'Aufkohlen',
  },
  nitriding: {
    header: 'Nitrieren',
    preNitridedCondition: 'Zustand vor Behandlung',
    estimatedTemperingConditions: 'Geschätzte Anlassbedingungen',
  },
  isnitridingHardnessEffective: {
    true: 'Effektiv',
    false: 'Kern +',
  },
  materialSimulationData: {
    header: 'Daten zur Werkstoffsimulation',
  },
  savePartAs: {
    header: 'Teil speichern unter',
  },
  newPartDisplayName: 'Neues Teil',
  cContent: 'C-Gehalt in wt%',
  nContent: 'N-Gehalt in wt%',
  cnContent: 'C/N-Gehalt in wt%',
  depthCore: 'Kern-Tiefe in mm',
  depth: 'Tiefe in mm',
  preprocessedProfile: 'Bestehendes Profil (Vorbehandlung)',
  parametrizedProfile: 'Parametrisiertes Profil',
  parametrizedProfileDescription: 'Definieren Sie das Profil Ihres Bauteils, indem Sie Oberflächen- und Kerngehalt angeben.',
  surfaceContent: 'Oberflächengehalt in wt%',
  coreContent: 'Kerngehalt in wt%',
  setpointsDescription: 'Erweitern Sie das Profil, indem Sie explizite Werte angeben.',
  surfaceHardnessCannotBeAchieved: 'Diese Oberflächenhärte kann nicht erreicht werden',
};
